import React from 'react'

import { BreadcrumbWrapper, StyledLink } from './styled-components'

const Breadcrumb = ({ category, baseLink }) => {
  return (
    <BreadcrumbWrapper>
      <StyledLink>{baseLink}</StyledLink> {'>'} {category}
    </BreadcrumbWrapper>
  )
}

export default Breadcrumb
